import React from 'react';
import { Video, Trash2 } from 'lucide-react';

export default function VideosTab({ uploadedVideos, checkVideoStatus, publishVideo, deleteVideo }) {
  return (
    <>
      <div className="bg-[#2a2a2a] rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#1a1a1a]">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Video
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Duration
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Uploaded
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {uploadedVideos.map((video) => (
                <tr key={video.video_id} className="hover:bg-[#333333] transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-4">
                      {video.thumbnail_url ? (
                        <img 
                          src={video.thumbnail_url} 
                          alt={video.title}
                          className="w-20 h-12 object-cover rounded"
                        />
                      ) : (
                        <div className="w-20 h-12 bg-gray-700 rounded flex items-center justify-center">
                          <Video className="w-6 h-6 text-gray-500" />
                        </div>
                      )}
                      <div>
                        <div className="text-white font-medium">{video.title}</div>
                        <div className="text-gray-400 text-sm">{video.teams || video.competition_name || 'No category'}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      video.status === 'ready' ? 'bg-emerald-900 text-emerald-200' :
                      video.status === 'processing' ? 'bg-blue-900 text-blue-200' :
                      video.status === 'pending' ? 'bg-yellow-900 text-yellow-200' :
                      'bg-red-900 text-red-200'
                    }`}>
                      {video.status === 'ready' ? 'Ready' :
                       video.status === 'processing' ? 'Processing' :
                       video.status === 'pending' ? 'Pending' :
                       'Failed'}
                    </span>
                    {video.published && (
                      <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-900 text-purple-200">
                        Published
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 text-gray-300">
                    {video.duration ? `${Math.floor(video.duration / 60)}m ${Math.floor(video.duration % 60)}s` : '-'}
                  </td>
                  <td className="px-6 py-4 text-gray-400 text-sm">
                    {new Date(video.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2">
                      {video.status === 'processing' || video.status === 'pending' ? (
                        <button
                          onClick={() => checkVideoStatus(video.video_id)}
                          className="px-3 py-1 text-blue-400 hover:text-blue-300 border border-blue-600 rounded transition-colors text-sm"
                          data-testid={`check-status-${video.video_id}`}
                        >
                          Check Status
                        </button>
                      ) : video.status === 'ready' && !video.published ? (
                        <button
                          onClick={() => publishVideo(video.video_id)}
                          className="px-3 py-1 bg-emerald-600 hover:bg-emerald-700 text-white rounded transition-colors text-sm"
                          data-testid={`publish-video-${video.video_id}`}
                        >
                          Publish
                        </button>
                      ) : null}
                      <button
                        onClick={() => deleteVideo(video.video_id)}
                        className="p-2 text-red-400 hover:text-red-300 transition-colors"
                        title="Delete"
                        data-testid={`delete-video-${video.video_id}`}
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {uploadedVideos.length === 0 && (
        <div className="text-center py-12 text-gray-400" data-testid="empty-videos">
          No videos uploaded yet. Click "Upload Video" to upload your first video.
        </div>
      )}
    </>
  );
}
